<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getDeliveryInstructionSubcontracts"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-di-number" label-cols-sm="4" label-cols-lg="3" label="DI Number" label-for="filter-di-number" size="sm" :model.sync="filter.diNumber" />
					<app-input-combobox-autocomplete :options="deliveryOrders" optionsLabel="doNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Order" id="filter-" size="sm" :model.sync="filter.deliveryOrderId" @input="getDeliveryOrders" @focus="getDeliveryOrders" />
					<app-input-textbox id="fieldset-po-no-customer" label-cols-sm="4" label-cols-lg="3" label="PO No Customer" label-for="filter-po-no-customer" size="sm" :model.sync="filter.poNoCustomer" />
					<app-input-datepicker-range  id="fieldset-di-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Delivery Date" size="sm" :modelFrom.sync="filter.diDeliveryDateFrom" :modelTo.sync="filter.diDeliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="deliveryInstructionStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Instruction Status" id="filter-" size="sm" :model.sync="filter.diStatusId" @input="getDeliveryInstructionStatuss" @focus="getDeliveryInstructionStatuss" />
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.diCustomerId" @input="getCustomers" @focus="getCustomers" />
					<!-- <app-input-combobox-autocomplete :options="partDestinations" optionsLabel="destination" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Destination" id="filter-" size="sm" :model.sync="filter.partDestinationId" @input="getPartDestinations" @focus="getPartDestinations" /> -->
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Destination" id="filter-" size="sm" :model.sync="filter.destinationId" @input="getCustomers" @focus="getCustomers" />
					<app-input-datepicker-range  id="fieldset-di-create-date" label-cols-sm="4" label-cols-lg="3" label="Create Date" size="sm" :modelFrom.sync="filter.diCreateDateFrom" :modelTo.sync="filter.diCreateDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getDeliveryInstructionSubcontracts"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Delivery Instruction Subcontract</span>
				</b-col>
				<b-col>
					<span v-if=false class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/deliveryinstructionsubcontract/DeliveryInstructionSubcontract.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="false"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-deliveryinstructionsubcontract" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="deliveryInstructionSubcontracts" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="deliveryInstructionSubcontracts.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="DI Number" class="table-filter">
					<b-form-input id="input-di-number-table" @input="getDeliveryInstructionSubcontractsWithoutLoading" v-model="filter.diNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Delivery Order" class="table-filter">
					<v-select append-to-body label="doNumber" :options="deliveryOrders" :value="filter.deliveryOrderId" :reduce="item => item.id" v-model="filter.deliveryOrderId" :filterable="true" @input="getDeliveryInstructionSubcontractsWithoutLoading" @search="getDeliveryOrders"></v-select>
				</b-th>
				<b-th stacked-heading="PO No Customer" class="table-filter">
					<b-form-input id="input-po-no-customer-table" @input="getDeliveryInstructionSubcontractsWithoutLoading" v-model="filter.poNoCustomer" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Delivery Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-di-delivery-date-from-table" reset-button @input="getDeliveryInstructionSubcontractsWithoutLoading" v-model="filter.diDeliveryDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-di-delivery-date-to-table" reset-button @input="getDeliveryInstructionSubcontractsWithoutLoading" v-model="filter.diDeliveryDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Delivery Instruction Status" class="table-filter">
					<v-select append-to-body label="name" :options="deliveryInstructionStatuss" :value="filter.diStatusId" :reduce="item => item.id" v-model="filter.diStatusId" :filterable="true" @input="getDeliveryInstructionSubcontractsWithoutLoading" @search="getDeliveryInstructionStatuss"></v-select>
				</b-th>
				<b-th stacked-heading="Customer" class="table-filter">
					<v-select append-to-body label="code" :options="customers" :value="filter.diCustomerId" :reduce="item => item.id" v-model="filter.diCustomerId" :filterable="true" @input="getDeliveryInstructionSubcontractsWithoutLoading" @search="getCustomers"></v-select>
				</b-th>
				<b-th stacked-heading="Part Destination" class="table-filter">
					<v-select append-to-body label="destination" :options="partDestinations" :value="filter.partDestinationId" :reduce="item => item.id" v-model="filter.partDestinationId" :filterable="true" @input="getDeliveryInstructionSubcontractsWithoutLoading" @search="getPartDestinations"></v-select>
				</b-th>
				<b-th stacked-heading="Destination" class="table-filter">
					<v-select append-to-body label="code" :options="customers" :value="filter.destinationId" :reduce="item => item.id" v-model="filter.destinationId" :filterable="true" @input="getDeliveryInstructionSubcontractsWithoutLoading" @search="getCustomers"></v-select>
				</b-th>
				<b-th stacked-heading="Office Address Destination" class="table-filter">
				</b-th>
				<b-th stacked-heading="Create Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-di-create-date-from-table" reset-button @input="getDeliveryInstructionSubcontractsWithoutLoading" v-model="filter.diCreateDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-di-create-date-to-table" reset-button @input="getDeliveryInstructionSubcontractsWithoutLoading" v-model="filter.diCreateDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>

						<!-- <b-th stacked-heading="Select All">
							<b-form-checkbox v-if="false" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th> -->
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(dinumber)="row">
						<a @click="() => ( $router.push({ name: 'deliveryinstructionsubcontractdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.diNumber != null && row.item.diNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.diNumber.slice(0, 30) + (row.item.diNumber.length > 30 ? "..." : "" ) : row.item.diNumber : "" }}
						</a>
					</template>

			<template v-slot:cell(deliveryOrder)="row">
				{{ row.item.deliveryOrder != null ? row.item.deliveryOrder.doNumber : "" }}
			</template>
			<template v-slot:cell(diDeliveryDate)="row">
				{{ row.item.diDeliveryDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(diCreateDate)="row">
				{{ row.item.diCreateDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(diStatus)="row">
				{{ row.item.diStatus != null ? row.item.diStatus.name : "" }}
			</template>
			<template v-slot:cell(diCustomer)="row">
				{{ row.item.diCustomer != null ? row.item.diCustomer.code : "" }}
			</template>
			<template v-slot:cell(partDestination)="row">
				{{ row.item.partDestination != null ? row.item.partDestination.destination : "" }}
			</template>
			<template v-slot:cell(destination)="row">
				{{ row.item.destination != null ? row.item.destination.code : "" }}
			</template>
			<template v-slot:cell(officeAddress)="row">
				{{ row.item.destination != null ? row.item.destination.officeAddress : "" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox v-if="false" :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="PO No Customer" label-for="input-po-no-customer" size="sm" :model.sync="row.item.poNoCustomer"   :isEditable="false" :isUpdatable="true" />
						<app-input-datepicker  id="fieldset-di-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="row.item.diDeliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-datepicker  id="fieldset-di-create-date" label-cols-lg="12"  label="Create Date" size="sm" :model.sync="row.item.diCreateDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.diStatusId" label="Delivery Instruction Status" :selected="row.item.diStatus != null ? row.item.diStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.diCustomerId" label="Customer" :selected="row.item.diCustomer != null ? row.item.diCustomer.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="destination" label-cols-sm="12" :model="row.item.partDestinationId" label="Part Destination" :selected="row.item.partDestination != null ? row.item.partDestination.destination : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.destinationId" label="Destination" :selected="row.item.destination != null ? row.item.destination.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-label label-cols-lg="12" size="sm" label="Office Address Destination" :model="(model.destination != null) ? model.destination.officeAddress : null"  />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(deliveryInstructionSubcontractsPaging != null ? deliveryInstructionSubcontractsPaging.dataCount : 0)"
									:per-page="(deliveryInstructionSubcontractsPaging != null ? deliveryInstructionSubcontractsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-deliveryinstructionsubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-deliveryinstructionsubcontract.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-deliveryinstructionsubcontract.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import DeliveryInstructionSubcontract from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontract';
import DeliveryInstructionSubcontractList from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractList';
import DeliveryInstructionSubcontractFilter from '@/filters/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import DeliveryOrderFilter from '@/filters/DeliveryOrder/DeliveryOrderFilter';
import DeliveryOrder from '@/models/DeliveryOrder/DeliveryOrder';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import DeliveryInstructionStatusFilter from '@/filters/DeliveryInstructionStatus/DeliveryInstructionStatusFilter';
import DeliveryInstructionStatus from '@/models/DeliveryInstructionStatus/DeliveryInstructionStatus';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';
import PartDestinationFilter from '@/filters/PartDestination/PartDestinationFilter';
import PartDestination from '@/models/PartDestination/PartDestination';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		DeliveryInstructionSubcontract, 
		DeliveryInstructionSubcontractList, 
		DeliveryInstructionSubcontractFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"diNumber": {}, "class" : "th-di-number first-child", "label" : "DI Number", key: 'diNumber', sortable: true}, 
				{"deliveryOrder": {}, "class" : "th-delivery-order", "label" : "Delivery Order", key: 'deliveryOrder', sortable: true}, 
				{"poNoCustomer": {}, "class" : "th-po-no-customer last-child", "label" : "PO No Customer", key: 'poNoCustomer', sortable: true}, 
				{"diDeliveryDate": {}, "class" : "th-di-delivery-date d-stack-none", "label" : "Delivery Date", key: 'diDeliveryDate', sortable: true}, 
				{"diStatus": {}, "class" : "th-di-status d-stack-none", "label" : "Delivery Instruction Status", key: 'diStatus', sortable: true}, 
				{"diCustomer": {}, "class" : "th-di-customer d-stack-none", "label" : "Customer", key: 'diCustomer', sortable: true}, 
				//{"partDestination": {}, "class" : "th-part-destination d-stack-none", "label" : "Part Destination", key: 'partDestination', sortable: true}, 
				{"destination": {}, "class" : "th-destination d-stack-none", "label" : "Destination", key: 'destination', sortable: true}, 
				{"officeAddress": {}, "class" : "th-office-address d-stack-none", "label" : "Office Address Destination", key: 'officeAddress', sortable: true}, 
				{"diCreateDate": {}, "class" : "th-di-create-date d-stack-none", "label" : "Create Date", key: 'diCreateDate', sortable: true}, 
				
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			deliveryInstructionSubcontracts: [],
			deliveryInstructionSubcontractsPaging: {},
			deliveryOrders : [],
			deliveryInstructionStatuss : [],
			customers : [],
			partDestinations : [],
			deliveryInstructionSubcontractDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	methods : {
		getDeliveryInstructionSubcontracts : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			DeliveryInstructionSubcontract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionSubcontracts = result.data
					this.deliveryInstructionSubcontractsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getDeliveryInstructionSubcontractsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			DeliveryInstructionSubcontract.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionSubcontracts = result.data
					this.deliveryInstructionSubcontractsPaging = result
				}
			})
			.catch(error => {});
		},
		getDeliveryOrders : async function(input) {
			let filter = new DeliveryOrderFilter();
			if (input != undefined) {
				filter.doNumber = input;
			}
			DeliveryOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrders = result.data
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructionStatuss : async function(input) {
			let filter = new DeliveryInstructionStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DeliveryInstructionStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		getPartDestinations : async function(input) {
			let filter = new PartDestinationFilter();
			if (input != undefined) {
				filter.destination = input;
			}
			PartDestination.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partDestinations = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new DeliveryInstructionSubcontractFilter();
			this.getDeliveryInstructionSubcontracts();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getDeliveryInstructionSubcontracts();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				DeliveryInstructionSubcontract.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			DeliveryInstructionSubcontract.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			DeliveryInstructionSubcontract.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			DeliveryInstructionSubcontract.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'deliveryinstructionsubcontractedit';
						if(this.isScannerMode) {
							createRoute = 'deliveryinstructionsubcontractscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			DeliveryInstructionSubcontract.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'deliveryinstructionsubcontractedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			DeliveryInstructionSubcontract.deleteData(this, id).then(result => {
				if (result)
				{
					this.getDeliveryInstructionSubcontracts();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				DeliveryInstructionSubcontract.deleteMultipleData(this).then(result => {
					this.getDeliveryInstructionSubcontracts();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableDeliveryInstructionSubcontractParent = document.getElementById('table-list-deliveryinstructionsubcontract').parentNode;
			tableDeliveryInstructionSubcontractParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableDeliveryInstructionSubcontractParent.scrollWidth - tableDeliveryInstructionSubcontractParent.offsetWidth) == Math.ceil(tableDeliveryInstructionSubcontractParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableDeliveryInstructionSubcontractParent = document.getElementById('table-list-deliveryinstructionsubcontract').parentNode;
			tableDeliveryInstructionSubcontractParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableDeliveryInstructionSubcontractParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new DeliveryInstructionSubcontractFilter();
		this.getDeliveryOrders()
		this.getDeliveryInstructionStatuss()
		this.getCustomers()
		this.getPartDestinations()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Delivery Instruction Subcontract"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getDeliveryInstructionSubcontracts();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getDeliveryInstructionSubcontracts();
			}
		},
		sortDesc: {
			handler: function() {
				this.getDeliveryInstructionSubcontracts();
			}
		},
		currentPage: {
			handler: function() {
				this.getDeliveryInstructionSubcontracts();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getDeliveryInstructionSubcontracts();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				DeliveryInstructionSubcontract.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "deliveryinstructionsubcontractindex") {
					this.getDeliveryInstructionSubcontractsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "delivery_instruction_subcontract").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
